import React, { Component } from 'react';

class CurrentCourseDetail extends Component {
    render() {
        return (
            <div>
                
            </div>
        );
    }
}

export default CurrentCourseDetail;